import { DEFAULT_SORT_ORDER, NEWEST, OLDEST } from 'constants/defaults'
import { uniq } from 'util/arrays'

function extractSearchTicketIds(search) {
  if (!search) return null
  const { pages } = search
  if (!pages) return null
  const pageValues = Object.values(pages)
  if (pageValues.length === 0) return []
  const ids = pageValues.reduce((a, b) => a.concat(b))
  return uniq(ids)
}

function sortToString(strOrObject) {
  let orderByWithDirection = strOrObject || ''
  if (orderByWithDirection && typeof strOrObject === 'object') {
    const { field, direction } = strOrObject
    // eslint-disable-next-line no-undef
    orderByWithDirection = [field, direction].join('_')
  }
  return orderByWithDirection
}

export const byNewest = (strOrObject = '') => {
  const orderByWithDirection = sortToString(strOrObject)
  return [
    NEWEST,
    'LAST_USER_MESSAGE_AT_DESC',
    'LAST_USER_OR_AGENT_MESSAGE_AT_DESC',
    'LAST_USER_OR_NOTE_MESSAGE_AT_DESC',
    'LAST_USER_AGENT_OR_NOTE_MESSAGE_AT_DESC',
    'LAST_UNANSWERED_USER_MESSAGE_AT_ASC',
  ].includes(orderByWithDirection)
}

export const byOldest = (strOrObject = '') => {
  const orderByWithDirection = sortToString(strOrObject)
  return [
    OLDEST,
    'LAST_USER_MESSAGE_AT_ASC',
    'LAST_USER_OR_AGENT_MESSAGE_AT_ASC',
    'LAST_USER_OR_NOTE_MESSAGE_AT_ASC',
    'LAST_USER_AGENT_OR_NOTE_MESSAGE_AT_ASC',
  ].includes(orderByWithDirection)
}

export const opposite = sortOrder => (byNewest(sortOrder) ? OLDEST : NEWEST)

const sortFuncs = {
  newest: (a, b) => Date.parse(b.updated_at) - Date.parse(a.updated_at),
  oldest: (a, b) => Date.parse(a.updated_at) - Date.parse(b.updated_at),
}

sortFuncs.default = sortFuncs[DEFAULT_SORT_ORDER]

export const sortSearchIds = (query, sortOrder, byId) => {
  const ids = extractSearchTicketIds(query)
  const sortFunc = sortFuncs[sortOrder] || sortFuncs.default
  const { queryId } = query
  const isIdQuery = !isNaN(queryId)
  const orderedResults = ids.sort((idA, idB) => {
    const a = byId[idA]
    const b = byId[idB]
    if (!a || !b) return 0
    if (isIdQuery) {
      if (a.id == queryId) return -1 // eslint-disable-line eqeqeq
      if (b.id == queryId) return 1 // eslint-disable-line eqeqeq
    }
    if (a.updated_at === b.updated_at) {
      if (a.id < b.id) return 1
      if (a.id > b.id) return -1
    }
    return sortFunc(a, b)
  })
  return orderedResults
}

export const sortByFunc = sort => sortFuncs[sort] || sortFuncs.default

const API_MAP = {
  newest: 'updated_at desc',
  oldest: 'updated_at asc',
}

API_MAP.default = API_MAP[DEFAULT_SORT_ORDER]

export const toGraphQL = sort => API_MAP[sort] || API_MAP.default

export const toParam = sortOrder => {
  if (!sortOrder) return ''
  return `?sort=${encodeURIComponent(sortOrder)}`
}
